import { Menu } from "@headlessui/react";
import { ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface CircleButtonProps {
  label: string;
  children: ReactNode;
  className?: string;
  title?: string;
}

export function RoundMenuButton({
  className,
  label,
  children,
  title,
}: CircleButtonProps) {
  const css = cn(
    className,
    " grid place-content-center text-sm rounded-full overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2",
    "focus:ring-offset-gray-900 focus:ring-white",
  );
  return (
    <Menu.Button className={css} title={title}>
      <span className="sr-only">{label}</span>
      {children}
    </Menu.Button>
  );
}
